export default class CreateAgentRequest {
    accountId: String;
    prefix: String;
    firstName: String;
    lastName: String;
    email: String;
    phone: String;
    ext: String;
    password: String;
    confirmPassword: String;
    country: String;
    address: String;
    city: String;
    state: String;
    postalCode: String;
    companyName: String;
    bookingAgent: Boolean = true;
}